export const NEPALI_WEEKDAYS = [
  "आइत",
  "सोम",
  "मंगल",
  "बुध",
  "बिही",
  "शुक्र",
  "शनि",
];

// Index 0 = Baisakh ... 11 = Chaitra
export const NEPALI_MONTHS = [
  "Baisakh",
  "Jestha",
  "Asar",
  "Shrawan",
  "Bhadra",
  "Aswin",
  "Kartik",
  "Mangsir",
  "Poush",
  "Magh",
  "Falgun",
  "Chaitra",
];

const NP_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

export const toNepaliDigits = (value) =>
  String(value).replace(/[0-9]/g, (d) => NP_DIGITS[d]);

export const isWeekendIndex = (weekday) => weekday === 0 || weekday === 6;
